(function () {
  var config = window.CelestiaLocalePersistence;

  if (!config || !Array.isArray(config.supportedLocales) || !config.supportedLocales.length) {
    return;
  }

  var STORAGE_KEY = 'celestia-preferred-locale';
  var COOKIE_KEY = 'celestia_preferred_locale';
  var PARAMS = ['lang', 'locale', 'language'];
  var supportedLocales = config.supportedLocales.map(normalizeLocale).filter(Boolean);
  var primaryLocale = normalizeLocale(config.primaryLocale) || supportedLocales[0];
  var currentLocale = normalizeLocale(config.currentLocale) || primaryLocale;
  var requestedLocale = getRequestedLocale();
  var preferredLocale = requestedLocale || getStoredLocale();

  if (!preferredLocale) {
    return;
  }

  setStoredLocale(preferredLocale);
  maybeRedirectToLocale(preferredLocale);
  persistLocaleOnLinks(preferredLocale);

  function normalizeLocale(value) {
    return String(value || '').toLowerCase().replace('_', '-').trim();
  }

  function matchSupportedLocale(value) {
    var normalized = normalizeLocale(value);

    if (!normalized) {
      return '';
    }

    for (var i = 0; i < supportedLocales.length; i += 1) {
      if (supportedLocales[i] === normalized || supportedLocales[i].split('-')[0] === normalized.split('-')[0]) {
        return supportedLocales[i];
      }
    }

    return '';
  }

  function getRequestedLocale() {
    var params = new URLSearchParams(window.location.search);

    for (var i = 0; i < PARAMS.length; i += 1) {
      var matched = matchSupportedLocale(params.get(PARAMS[i]));

      if (matched) {
        return matched;
      }
    }

    return '';
  }

  function getStoredLocale() {
    var stored = '';

    try {
      stored = window.localStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
      stored = '';
    }

    if (!stored) {
      stored = getCookie(COOKIE_KEY);
    }

    return matchSupportedLocale(stored);
  }

  function setStoredLocale(locale) {
    try {
      window.localStorage.setItem(STORAGE_KEY, locale);
    } catch (error) {
      // Ignore storage errors, cookie fallback below keeps the preference.
    }

    document.cookie = COOKIE_KEY + '=' + encodeURIComponent(locale) + '; path=/; max-age=31536000; SameSite=Lax';
  }

  function getCookie(name) {
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0; i < cookies.length; i += 1) {
      var parts = cookies[i].split('=');

      if (parts[0] === name) {
        return decodeURIComponent(parts.slice(1).join('='));
      }
    }

    return '';
  }

  function maybeRedirectToLocale(locale) {
    var currentUrl = new URL(window.location.href);
    var cleanUrl = new URL(currentUrl.href);

    PARAMS.forEach(function (param) {
      cleanUrl.searchParams.delete(param);
    });

    var localizedUrl = localizeUrl(cleanUrl, locale);
    var currentPathLocale = getPathLocale(currentUrl.pathname);
    var needsLocaleChange = locale !== currentLocale || locale !== currentPathLocale;
    var needsParamCleanup = cleanUrl.href !== currentUrl.href;

    if (needsLocaleChange || needsParamCleanup) {
      window.location.replace(localizedUrl.href);
    }
  }

  function persistLocaleOnLinks(locale) {
    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest && event.target.closest('a[href]');

        if (!link || link.target || link.hasAttribute('download')) {
          return;
        }

        var url;

        try {
          url = new URL(link.href, window.location.origin);
        } catch (error) {
          return;
        }

        if (url.origin !== window.location.origin || shouldSkipPath(url.pathname)) {
          return;
        }

        var localizedUrl = localizeUrl(url, locale);

        if (localizedUrl.href !== url.href) {
          link.href = localizedUrl.href;
        }
      },
      true
    );
  }

  function localizeUrl(url, locale) {
    var localizedUrl = new URL(url.href);
    var path = stripLocalePrefix(localizedUrl.pathname);

    if (locale === primaryLocale) {
      localizedUrl.pathname = path;
      return localizedUrl;
    }

    localizedUrl.pathname = '/' + locale + (path === '/' ? '' : path);
    return localizedUrl;
  }

  function getPathLocale(pathname) {
    var firstSegment = normalizeLocale((pathname || '/').split('/').filter(Boolean)[0]);
    var matched = matchSupportedLocale(firstSegment);

    return matched || primaryLocale;
  }

  function stripLocalePrefix(pathname) {
    var parts = (pathname || '/').split('/').filter(Boolean);

    if (parts.length && matchSupportedLocale(parts[0])) {
      parts.shift();
    }

    return '/' + parts.join('/');
  }

  function shouldSkipPath(pathname) {
    return /^\/(admin|account|apps|cdn|challenge|tools)\b/.test(pathname || '');
  }
})();
